import createApiService, { TServiceReturns } from "@lib/create-api-service";
import { OrderFields } from "@modules/order/constants";
import { API_ROUTES } from "@utils/constants";

import type { TAddressRequestParams, TUpdateAddressForm } from "../types";
import mapUpdateAddressToRequestParams from "../utils/mapUpdateAddressToRequestParams";
import mapUpdateResponseErrorsToFields from "../utils/mapUpdateResponseErrorsToFields";

const updateAddressBookService = createApiService<unknown, Partial<TAddressRequestParams>>({ allowedErrStatus: 422 });

const updateAddressBookEntry = async (
  form: Partial<TUpdateAddressForm>
): Promise<TServiceReturns<unknown, TUpdateAddressForm>> => {
  // At this point data is valid
  const data = mapUpdateAddressToRequestParams(form as TUpdateAddressForm);

  const addressId = form[OrderFields.RECEIVER_ADDRESS_ID]!;

  const response = await updateAddressBookService({
    url: API_ROUTES.getUserDataAddressBookById(addressId),
    method: "PUT",
    data,
  });
  if (response.isSuccess) {
    return response;
  }

  return {
    ...response,
    isSuccess: false,
    errorDetails: mapUpdateResponseErrorsToFields(response.errorDetails || {}),
  };
};
export default updateAddressBookEntry;
